module.exports = {
  hideYearsOnSelect: true,
  layout: 'portrait',
  overscanMonthCount: 2,
  shouldHeaderAnimate: true,
  showHeader: true,
  showMonthsForYears: true,
  showOverlay: true,
  showTodayHelper: true,
  showWeekdays: true,
  todayHelperRowOffset: 4
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-infinite-calendar/es/utils/defaultDisplayOptions.js
// module id = 921
// module chunks = 0